import AuthClient from "./AuthClient";

const ChabadHousesApi = {
  getChabadHousesDetails: async (cancelToken, filterToHasCampus = true) => {
    const chabadHousesResponse = await AuthClient.get("ChabadHouses/Detailed", {
      cancelToken,
    });

    const chabadHouses = chabadHousesResponse.data.payload || [];

    return filterToHasCampus
      ? chabadHouses.filter((ch) => !!ch.campusID)
      : chabadHouses;
  },

  getChabadHouseShluchim: async (cancelToken, 
    chabadHouseId, 
    isPrimary = false
  ) => {
    const params = { isPrimary };
    
    const response = await AuthClient.get(
      `ChabadHouses/${chabadHouseId}/Shluchim`,
      { params, cancelToken },
    );
    return response.data.payload || [];
  },

  getChabadHouseStudents: async (
    cancelToken,
    chabadHouseId,
    { isPrimary = true, recentLoginWeeks = null } = {},
  ) => {
    const params = {
      isPrimary,
      recentLoginWeeks,
    };

    const response = await AuthClient.get(
      `ChabadHouses/${chabadHouseId}/Students/Basic`,
      { params, cancelToken },
    );
    return response.data.payload || [];
  },
};

export default ChabadHousesApi;
